import FormHeader from "@/components/booking/FormHeader.tsx";
// import {useContext} from "react";
// import {OscarContext, OscarContextType} from "@/components/context/OscarContext.tsx";
import {FormControl, FormField, FormItem, FormLabel} from "@/components/ui/form.tsx";
import {RadioGroup, RadioGroupItem} from "@/components/ui/radio-group.tsx";
import {useFormContext} from "react-hook-form";
import {z} from "zod";
import {BookingFormSchema} from "@/components/booking/form/BookingFormSchema.ts";
import {BookingKind, BookingKindHelper} from "@/lib/enum/BookingKind.ts";

export function BinKindForm() {
    // const {appConfig, localConfig} = useContext(OscarContext) as OscarContextType
    const {control, watch, setValue, resetField} = useFormContext<z.infer<typeof BookingFormSchema>>();

    // Get the bin size.
    const binKind = watch("binKind");

    const onKindChange = (kind: BookingKind) => {
        resetField("binSize");
        resetField("binType");
        setValue("binKind", kind);
    }

    return (
        <div className={"os-app-row os-flex os-flex-col os-gap-4"}>
            <FormHeader>Bin Kind</FormHeader>
            <FormField
                key={binKind || "binKind"}
                control={control}
                name="binKind"
                render={({field}) => (
                    <FormItem>
                        <FormLabel>What kind of bin would you like?</FormLabel>
                        <FormControl>
                            <RadioGroup
                                onValueChange={onKindChange}
                                defaultValue={field.value}
                            >
                                {BookingKindHelper.getOptions().map((binKind) => (
                                    <FormItem
                                        key={binKind}
                                        className="os-flex os-flex-row os-items-center os-justify-center os-gap-2 os-flex-1 !os-space-y-0 os-py-2">
                                        <FormControl className={"os-brand-text"}>
                                            <RadioGroupItem value={binKind}/>
                                        </FormControl>
                                        <FormLabel className="font-normal">
                                            {BookingKindHelper.getBookingKindLabel(binKind)}
                                        </FormLabel>
                                    </FormItem>
                                ))}
                            </RadioGroup>
                        </FormControl>
                    </FormItem>
                )}
            />
        </div>
    );
}
